// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DropboxIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <g fill="#0061FE" clipPath="url(#dropbox_svga)">
      <path d="M6.65 3.23 1.35 6.6l5.3 3.37 5.3-3.37 5.3 3.37 5.29-3.37-5.3-3.37-5.3 3.37zM6.65 16.7l-5.3-3.36 5.3-3.37 5.3 3.37z" />
      <path d="m11.94 13.34 5.3-3.37 5.3 3.37-5.3 3.37zM11.94 21.2l-5.3-3.37 5.3-3.37 5.3 3.37z" />
    </g>
    <defs>
      <clipPath id="dropbox_svga">
        <path fill="#fff" d="M1 3h22v18.33H1z" />
      </clipPath>
    </defs>
  </svg>,
  "Dropbox",
);
export default DropboxIcon;
